import { Comparable, ComparableResult } from './types';

export function compareByNumber<T>(
    getter: (item: T) => number,
    options: { order: 'asc' | 'desc' } = { order: 'asc' },
): Comparable<T> {
    return (left: T, right: T) => {
        const numA = getter(left) * (options.order === 'desc' ? -1 : 1);
        const numB = getter(right) * (options.order === 'desc' ? -1 : 1);
        if (numA === numB) {
            return ComparableResult.equal;
        } else if (numA < numB) {
            return ComparableResult.less;
        }
        return ComparableResult.greater;
    };
}
